import { render } from "./app-section-divider.vue?vue&type=template&id=050e0c9c&ts=true"
import script from "./app-section-divider.vue?vue&type=script&lang=ts"
export * from "./app-section-divider.vue?vue&type=script&lang=ts"

import "./app-section-divider.vue?vue&type=style&index=0&id=050e0c9c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__